var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSessionWithBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E0EFFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5V20M18.25 21.5V18.5M20.5 21.5V17M22 24.5H14.5C14.1022 24.5 13.7206 24.342 13.4393 24.0607C13.158 23.7794 13 23.3978 13 23V12.5C13 12.1022 13.158 11.7206 13.4393 11.4393C13.7206 11.158 14.1022 11 14.5 11H18.6895C18.8884 11 19.0791 11.0791 19.2198 11.2197L23.2803 15.2802C23.4209 15.4209 23.5 15.6116 23.5 15.8105V23C23.5 23.3978 23.342 23.7794 23.0607 24.0607C22.7794 24.342 22.3978 24.5 22 24.5Z",
    stroke: "#007DFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#DDDEDF",
    strokeOpacity: 0.2,
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionWithBg);
export default __webpack_public_path__ + "static/media/sessionWithBg.56256e280ade89cb9777c1583f21fc4e.svg";
export { ForwardRef as ReactComponent };